module.exports = __webpack_public_path__ + "static/img/1.1a3f022.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/UltralowTemperature/R508B/1.jpg
// module id = qnmp
// module chunks = 1